import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { MultiSelectComponent } from '@progress/kendo-angular-dropdowns';
@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-multiselect',
  templateUrl:
    'console/app-js/shared/components/multiselect/multiselects.component.html'
})
export class MultiselectsComponent implements OnInit, OnChanges {
  @ViewChild('kendoMultiSelectInstance', { static: true })
  public kendoMultiSelectInstance: MultiSelectComponent;
  @Input() listItems: any; // data
  @Input() loadingIndicator: string;
  @Input() value: string;
  @Input() id: string;
  @Input() selection: Array<any> = [];
  @Input() expandCheckboxes: boolean = false;
  @Input() autoClose: boolean = true;
  @Input() placeholder: string='';
  @Input() popupSettings: any;
  @Output() filterChange = new EventEmitter();
  @Output() close = new EventEmitter();
  @Output() valueChange = new EventEmitter<any>();
  @Output() keypress = new EventEmitter<any>();
  source: any;

  ngOnInit() {
    this.source = this.listItems.slice();
    if (
      this.expandCheckboxes == true &&
      this.source &&
      this.source.length > 0
    ) {
      this.kendoMultiSelectInstance.toggle(true);
    }
  }

  /**
   * Implementation from OnChanges interface
   * On every change of the current selection of values.
   */
  public ngOnChanges(): void {
    this.source = this.listItems.slice();
  }

  /**
   * Filter data from multiselect dropdown
   *
   */
  onFilterChange(filter: string) {
    if (this.filterChange) {
      this.filterChange.emit(filter);
    }
  }

  /**
   * Event emits on key press
   *
   */
  onKeyPress($event) {
    this.keypress.emit($event);
  }

  /**
   * This hacky code will always set the scroll to top index element when the dropdown closes.
   * @param $event
   */
  setFocusToTopIndex($event): void {
    if ($event) {
      $event.preventDefault();
    }
    this.kendoMultiSelectInstance['selectionService'].focusedIndex = 0;
    this.kendoMultiSelectInstance.toggle(false);
  }

  /**
   * Event emits on value change
   *
   */
  public onValueChange(value: any): void {
    this.valueChange.emit(value ? value : null);
  }

  public isItemSelected(itemText: string, dataItem: any): boolean {
    return this.selection.some((item) => item.name === itemText);
  }
}
